import { ReactElement, ReactNode } from "react";

const ConditionCheck = ({
  conditions,
  fallback = null,
  children,
}: {
  conditions: boolean[];
  fallback?: ReactElement | null;
  children: ReactNode | null;
}): ReactElement | null => {
  return conditions.every((condition) => condition)
    ? (children as ReactElement)
    : fallback;
};

export default ConditionCheck;
